module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile_79e69e.jpg";